import { render, staticRenderFns } from "./TabRisks.vue?vue&type=template&id=13b01022&"
import script from "./TabRisks.vue?vue&type=script&lang=js&"
export * from "./TabRisks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports